import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import _ from 'lodash';

import TilePlan from './TilePlan';
import PlansFilter from './PlansFilter';
import { connect } from 'react-redux';
import Constants from '../../services/Constants';
import { PlansTableWithClientColumnDefs } from './documents/ColumnDefs';
import DocumentsGridTree from './documents/DocumentsGridTree';

class ClientPlans extends Component {
  renderRequestAccess = (email, plan) => {
    const { planAdministratorEmail, planName, fullName } = plan;
    const subject = `NEPC ClientHUB access request to ${planName}`;
    const body = `Hello,

I would like to request access to the ${planName} portfolio on the NEPC ClientHUB.

Thanks,
${fullName}`;
    let requestAccess = 'mailto:';
    requestAccess += planAdministratorEmail;
    requestAccess += '?subject=' + encodeURI(subject);
    requestAccess += '&body=' + encodeURI(body).replace('%0A', '%0D%0A');
    return requestAccess;
  };

  renderPlan = (plan) => {
    const email = this.props.user && this.props.user.email;
    const requestAccess = this.renderRequestAccess(email, plan);
    return (
      <Row className="mb-2" key={plan.planId}>
        <Col lg={10}>{plan.planName}</Col>
        <Col lg={2}>
          <a className="btn btn-secondary" role="button" href={requestAccess}>
            Request Access
          </a>
        </Col>
      </Row>
    );
  };

  renderDisabledPlans = (disabledPlans) => {
    if (disabledPlans.length > 0) {
      const plans = disabledPlans.map(this.renderPlan);
      return (
        <div className="plansDisabled">
          <p>
            You are associated with the plan(s) listed below but have not been
            granted access. Use appropriate Request Access button to create an
            email you can send to the plan administrator.
          </p>
          {plans}
        </div>
      );
    }
    return null;
  };

  renderEnabledPlans = (enabledPlans) => {
    const tiles = _.map(enabledPlans, (plan) => (
      <TilePlan
        key={plan.planId}
        plan={plan}
        isEmployee={false}
        isMyPlans={false}
      />
    ));
    return <div className="tilesWrapper">{tiles}</div>;
  };

  filterByEntityType = (filter, data) => {
    const entityTypeFilter = filter[Constants.ENTITY_TYPE];
    if (entityTypeFilter) {
      return data.filter(
        (d) =>
          entityTypeFilter.includes(Constants.ALL) ||
          entityTypeFilter.includes(d[Constants.ENTITY_TYPE])
      );
    }
    return data;
  };

  filterByPlan(filter, data) {
    const planFilter = filter[Constants.PLAN_NAME];
    if (planFilter) {
      data = data.filter(
        (d) =>
          planFilter.includes(Constants.ALL) ||
          d[Constants.PLAN_NAME]
            .toUpperCase()
            .includes(planFilter[0].toUpperCase())
      );
    }
    return data;
  }

  filterByClient(filter, data) {
    const clientFilter = filter[Constants.CLIENT_NAME];
    if (clientFilter) {
      data = data.filter(
        (d) =>
          clientFilter.includes(Constants.ALL) ||
          d[Constants.CLIENT_NAME]
            .toUpperCase()
            .includes(clientFilter[0].toUpperCase())
      );
    }
    return data;
  }

  applyFilters = (plans) => {
    const filter = this.props.filterPlansBy;
    let filteredData = plans;

    if (filteredData && filter) {
      filteredData = this.filterByEntityType(filter, filteredData);
      filteredData = this.filterByPlan(filter, filteredData);
      filteredData = this.filterByClient(filter, filteredData);
    }
    return filteredData;
  };

  isSingleClient = (enabledPlans) => {
    return _.uniqBy(enabledPlans, 'clientName').length == 1;
  };

  render() {
    const [enabledPlans, disabledPlans] = _.partition(this.props.plans, {
      accessEnabled: true,
    });

    return (
      <div>
        <PlansFilter
          data={this.applyFilters(enabledPlans)}
          isMyplans={true}
          documentView={Constants.PLANS_VIEW}
          singleClient={this.isSingleClient(enabledPlans)}
        />
        {Boolean(this.props.portfoliosViewModel) && (
          <div className="plansTable">
            <DocumentsGridTree
              rowData={this.applyFilters(enabledPlans)}
              columnDefs={PlansTableWithClientColumnDefs}
              isLoading={this.props.plansRequest.loading}
              hasLoaded={this.props.plansRequest.isLoaded}
              headerHeight={65}
              groupDefaultExpanded={1}
            />
            {this.renderDisabledPlans(disabledPlans)}
          </div>
        )}
        {Boolean(!this.props.portfoliosViewModel) && (
          <>
            {this.renderEnabledPlans(this.applyFilters(enabledPlans))}
            {this.renderDisabledPlans(disabledPlans)}
          </>
        )}
      </div>
    );
  }
}

ClientPlans.propTypes = {
  filterPlansBy: PropTypes.object,
  plansRequest: PropTypes.object,
  plans: PropTypes.array.isRequired,
  user: PropTypes.object,
  portfoliosViewModel: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    filterPlansBy: state.ui.filterBy[Constants.PLANS_VIEW],
    portfoliosViewModel: state.ui.portfoliosViewModel,
    plansRequest: state.resources.plans,
  };
};

export default connect(mapStateToProps)(ClientPlans);
